<template>
  <v-row class="footer">
    <span class="footer--text">
      &copy; Copyright 2020-{{ new Date().getFullYear() }} <a href="/" target="_blank" title="Britecheck.com">Britecheck</a>, All rights reserved.
    </span>
  </v-row>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
